import type { SVGProps } from "react";

export function IconDarkPurpleFunding(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 33 33"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="16.5"
        y="4.125"
        width="12.375"
        height="24.75"
        stroke="#3E2247"
        strokeWidth="2.0625"
      />
      <path
        d="M10.3125 16.5L4.125 16.5V28.875"
        stroke="#3E2247"
        strokeWidth="2.0625"
        strokeLinecap="square"
      />
      <path
        d="M10.3125 28.875V10.3125H16.5"
        stroke="#3E2247"
        strokeWidth="2.0625"
        strokeLinecap="square"
      />
      <ellipse
        cx="22.6875"
        cy="16.5"
        rx="6.1875"
        ry="4.125"
        stroke="#3E2247"
        strokeWidth="2.0625"
      />
    </svg>
  );
}
